module.exports = __webpack_public_path__ + "images/amazon-aplus-blue-ddd97741.svg";